module.exports = __webpack_public_path__ + "static/media/icon-chevron-left.5727f869.svg";